var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3586 15.1414C30.4367 15.0633 30.5633 15.0633 30.6414 15.1414L33.187 17.687C33.2651 17.7651 33.2651 17.8917 33.187 17.9698L31.2071 19.9497L28.3787 17.1213L30.3586 15.1414ZM16.8268 31.8116C16.6697 31.865 16.5198 31.715 16.5731 31.558L17.8971 27.6592L20.7256 30.4876L16.8268 31.8116ZM30.3284 20.8284L27.5 18L18.3076 27.1924L21.136 30.0208L30.3284 20.8284Z",
    fill: "#002B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5d6df18577847b340fba5f8078e276ed.svg";
export { ForwardRef as ReactComponent };